import React, { useState, useEffect, useCallback, useRef } from "react";
import { useParams } from 'react-router-dom';
import "./../../pagescss/QuizStarting.css";
import AllQuestions from "../AllData/AllQuestions";
import AllDemoQuestions from "../AllData/AllDemoQuestions";
import { formatTime, getCurrentOptions } from "./quiz/utils/quizUtils";
import { filterQuestions } from "./quiz/utils/questionFilter";
import { QuizResults } from "./quiz/components/QuizResults";
import { QuizStartScreen } from "./quiz/components/QuizStartScreen";
import { QuestionNavigation } from "./quiz/components/QuestionNavigation";
import { useQuizHandlers } from "./quiz/hooks/useQuizHandlers";
import { FaBars, FaTimes } from "react-icons/fa";
import Latex from 'react-latex';
import snum from './num';
import QuestionImage from "./QuestionImage";






function QuizStarting() {
  const phone = "12345";
  const { type, subject, topic, quizNo, quesNum, subjectName } = useParams();
  const quizNum = quizNo ? parseInt(quizNo) : null;

  const [randomQuestions, setQuestions] = useState([]);
  const shuffleQuestions = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  useEffect(() => {
    let shuffledQuestions;

    if ((quizNo == 0 && topic == "atoz") || (quizNo == 0 && (topic == "CP01" || topic == "CC01" || topic == "CB01"))) {
      shuffledQuestions = shuffleQuestions(AllDemoQuestions);

    } else {
      shuffledQuestions = shuffleQuestions(AllQuestions);
    }
    setQuestions(shuffledQuestions);
  }, []);


  {/*   without demo
      useEffect(() => {
     const shuffledQuestions = shuffleQuestions(AllQuestions);
    setQuestions(shuffledQuestions);
  }, []);      */}





  let TotallQuestionNumber = 15;
  if (quesNum >= 200) {
    TotallQuestionNumber = 180;
  } else if (quesNum <= 10) {
    TotallQuestionNumber = 10;
  } else {
    TotallQuestionNumber = quesNum;
  }


  const questions = filterQuestions(randomQuestions, type, subject, topic, quizNo, quizNum, TotallQuestionNumber, snum);
  const totalQuizTimeInSeconds = questions.length * 60;

  const [quizStart, setQuizStart] = useState(false);
  const [timeLeft, setTimeLeft] = useState(totalQuizTimeInSeconds);
  const [showSidebar, setShowSidebar] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const quizId = `${type}${subject}${topic}${quizNo}`;
  const quizName = subjectName;

  // First, call the hook to get handleSubmit
  const {
    selectedAnswers,
    markedQuestions,
    hasSelectedOption,
    currentQuestionIndex,
    isSubmitted,
    score,
    handleOptionChange,
    handleNextQuestion,
    handlePreviousQuestion,
    handleQuestionButtonClick,
    toggleMarkQuestion,
    handleSubmit, // This is from useQuizHandlers
    handleStartQuiz,
  } = useQuizHandlers(
    questions,
    phone,
    quizId,
    quizName,
    totalQuizTimeInSeconds,
    timeLeft
  );

  // Now define customSubmitHandler AFTER handleSubmit is available
  const customSubmitHandler = useCallback(async (isTimeUp = false) => {
    if (!isTimeUp) {
      // Show modal instead of using confirm
      setShowConfirmModal(true);
      return;
    }

    // If time is up, submit directly using the hook's handleSubmit
    if (handleSubmit) {
      handleSubmit(true);
    }
  }, [handleSubmit]); // Add handleSubmit to dependencies

  const handleConfirmSubmit = async () => {
    setShowConfirmModal(false);
    // Use the handleSubmit from the hook
    if (handleSubmit) {
      handleSubmit(false);
    }
  };

  const handleCancelSubmit = () => {
    setShowConfirmModal(false);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      if (window.innerWidth >= 768) {
        setShowSidebar(true);
      } else {
        setShowSidebar(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const startQuiz = () => {
    handleStartQuiz();
    setQuizStart(true);
    setTimeLeft(totalQuizTimeInSeconds);
    window.history.pushState(null, '', window.location.href);
  };

  useEffect(() => {
    if (timeLeft > 0 && !isSubmitted && quizStart) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => prevTime - 1);
      }, 1000);

      return () => clearInterval(timer);
    } else if (timeLeft === 0 && !isSubmitted && quizStart) {
      // Use customSubmitHandler instead of handleSubmit directly
      customSubmitHandler(true);
    }
  }, [timeLeft, isSubmitted, quizStart, customSubmitHandler]);

  const currentQuestion = questions[currentQuestionIndex];
  const answeredCount = hasSelectedOption.filter((selected) => selected).length;
  const unansweredCount = questions.length - answeredCount;
  const markedCount = markedQuestions.filter((mark) => mark).length;

  const renderWithLatex = (text) => {
    if (!text) return null;
    if (text.includes('$') || text.includes('\\')) {
      return <Latex>{text}</Latex>;
    }
    return text;
  };

  {/*
  // Not leaving 
  useEffect(() => {
    if (!quizStart) return;
    const handleBeforeUnload = (e) => {
      e.preventDefault();
      e.returnValue = 'Are you sure you want to leave? Your quiz progress will be lost.';
      return e.returnValue;
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    const handlePopState = (e) => {
      if (quizStart) {
        e.preventDefault();
        window.history.pushState(null, '', window.location.href);
      }
    };
    window.history.pushState(null, '', window.location.href);
    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [quizStart]);
  */}


  const [showContent, setShowContent] = useState(false);
  const handleToggle = () => {
    setShowContent(!showContent);
  };


  return (
    <>
      {quizStart ? (
        <div className="quiz-container">
          {/* Mobile Menu Button */}
          {isMobile && (
            <button
              className="mobile-menu-button"
              onClick={() => setShowSidebar(!showSidebar)}
            >
              {showSidebar ? <FaTimes /> : <FaBars />}
            </button>
          )}

          {/* Sidebar */}
          <div className={`quiz-sidebar ${showSidebar ? 'show' : ''}`}>
            <div className="sidebar-content">
              <div className="sidebar-header-quiz">
                <h4>{quizName} mock test</h4>
              </div>

              <div className="question-stats">
                <div className="stat-item">
                  <span className="stat-label">Total:</span>
                  <span className="stat-value">{questions.length}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label answered">Answered:</span>
                  <span className="stat-value">{answeredCount}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label unanswered">Unanswered:</span>
                  <span className="stat-value">{unansweredCount}</span>
                </div>
                <div className="stat-item">
                  <span className="stat-label marked">Marked:</span>
                  <span className="stat-value">{markedCount}</span>
                </div>
              </div>

              <div className="question-navigation">
                <QuestionNavigation
                  questions={questions}
                  hasSelectedOption={hasSelectedOption}
                  currentQuestionIndex={currentQuestionIndex}
                  markedQuestions={markedQuestions}
                  handleQuestionButtonClick={(index) => {
                    handleQuestionButtonClick(index);
                    if (isMobile) setShowSidebar(false);
                  }}
                />
              </div>
            </div>
          </div>

          {/* Main Content */}
          <div className="quiz-main-content">
            <div className="main-content-inner">
              <div className="quiz-header">
                {!isMobile && (<h1>{quizName} mock test</h1>)}
                {isMobile && (
                  <div className="timer-mobile">
                    <span>Time Left: </span>
                    <span className="time-value">{formatTime(timeLeft)}</span>
                  </div>
                )}

                {!isMobile && (
                  <div className="timer">
                    <span>Time Left: </span>
                    <span className="time-value">{formatTime(timeLeft)}</span>
                  </div>
                )}
              </div>

              {/* 
          
              {questions.map((user) => (
                <div key={user.id}>
                  {user.topic}
                </div>
              ))}

              {snum}


              <br></br><br></br>

              */}



              {!isSubmitted ? (
                <>
                  <div className="question-container">

                    <div className="question-section">

                      <p className="question-number">Question:  {currentQuestionIndex + 1} of {questions.length}</p>

                      {currentQuestion.type === "dpp" ? (<>
                        {currentQuestion.question ? (
                          
                          <p className="question-text">
                             
                            {renderWithLatex(currentQuestion.question)}
                          </p>
                        ) : (
                          <QuestionImage
                            src={`/questionsPhoto/${currentQuestion.question_img}`}
                            alt="Question"
                          />
                        )}

                        <button onClick={handleToggle} style={{ fontSize: "8px", padding: "01px" }}>
                          {showContent ? "Hide source image" : "View source image"}
                        </button>
                        {showContent && (
                          <div style={{ padding: "5px" }}>
                            <QuestionImage
                              src={`/questionsPhoto/${currentQuestion.question_img}`}
                              alt="Question"
                            />
                          </div>
                        )}

                      </>) : (<>
                        {currentQuestion.question_img ? (
                          <QuestionImage
                            src={`/questionsPhoto/${currentQuestion.question_img}`}
                            alt="Question"
                          />
                        ) : (
                          <>{renderWithLatex(currentQuestion.question)}</>
                        )}
                      </>)}

                    </div>


                    {/*   <p>{currentQuestion.type}</p>    */}


                    <div className="options-section">
                      {getCurrentOptions(currentQuestion).map((option, index) => (
                        <div key={index} className="">
                          <label className="option-label">
                            <input
                              type="radio"
                              name="option"
                              value={`option${index + 1}`}
                              checked={selectedAnswers[currentQuestionIndex] === `option${index + 1}`}
                              onChange={handleOptionChange}
                              className="option-input"
                            />
                            <span className="option-letter">({String.fromCharCode(65 + index)})</span>
                            <span className="option-text">{renderWithLatex(option.label)}</span>
                          </label>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="navigation-buttons">
                    <button
                      onClick={handlePreviousQuestion}
                      disabled={currentQuestionIndex === 0}
                      className="nav-button prev-button"
                    >
                      Previous
                    </button>
                    <button
                      onClick={toggleMarkQuestion}
                      className={`nav-button mark-button ${markedQuestions[currentQuestionIndex] ? 'marked' : ''}`}
                    >
                      {markedQuestions[currentQuestionIndex] ? "Unmark" : "Mark"}
                    </button>
                    {currentQuestionIndex < questions.length - 1 ? (
                      <button
                        onClick={handleNextQuestion}
                        className="nav-button next-button"
                      >
                        Next
                      </button>
                    ) : (
                      <button
                        onClick={() => customSubmitHandler(false)} // Use customSubmitHandler here
                        className="nav-button submit-button"
                      >
                        Submit
                      </button>
                    )}
                  </div>
                </>
              ) : (
                <QuizResults
                  score={score}
                  questions={questions}
                  quizId={quizId}
                />
              )}
            </div>
          </div>
        </div>
      ) : (
        <QuizStartScreen
          questions={questions}
          totalQuizTimeInSeconds={totalQuizTimeInSeconds}
          subjectName={subjectName}
          handleStartQuiz={startQuiz}
        />
      )}

      {/* Confirmation Modal */}
      {showConfirmModal && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          zIndex: 1000
        }}>
          <div style={{
            background: 'white',
            padding: '2rem',
            borderRadius: '8px',
            maxWidth: '400px',
            width: '90%',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)'
          }}>
            <h3>Confirm Submission</h3>
            <p>Are you sure you want to submit your answers and finish the exam?</p>
            <div style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '1rem',
              marginTop: '1.5rem'
            }}>
              <button
                onClick={handleCancelSubmit}
                style={{
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '4px',
                  background: '#cff305ff',
                  cursor: 'pointer'
                }}
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmSubmit}
                style={{
                  padding: '0.5rem 1rem',
                  border: 'none',
                  borderRadius: '4px',
                  background: '#007bff',
                  color: 'white',
                  cursor: 'pointer'
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default QuizStarting;